import { Button, PAGE_DEFAULT, PAGE_SIZE_UNLIMITED, Stack, Typography } from "@compass/core";
import { ReorderDataModels } from "components";
import { DataModelEnum, Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import ApiService from "services/apiService";
import { contributorMatchServicePageRoute } from "../ContributorMatchServicePage/ContributorMatchServicePage";

export const ContributorMatchServiceListPageHeader = (props: { rootPermission: Permission; handle: string }) => {
  const navigate = useNavigate();

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Typography variant="inherit">{props.handle}</Typography>

        {isAuthorized(props.rootPermission, PermissionAction.Update) && (
          <ReorderDataModels
            dataModelEnum={DataModelEnum.ContributorMatchService}
            handle={props.handle}
            getId={(item) => item.id}
            getName={(item) => item.name}
            getDisplayOrder={(item) => item.displayOrder}
            fetch={() =>
              ApiService.contributorMatchServices.getList({
                page: PAGE_DEFAULT,
                pageSize: PAGE_SIZE_UNLIMITED,
              })
            }
          />
        )}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        {isAuthorized(props.rootPermission, PermissionAction.Create) && (
          <Button
            onClick={() => navigate(contributorMatchServicePageRoute.getPath({ id: 0, crudMode: "edit" }))}
            variant="outlined"
          >
            + New
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
